import { createAsyncThunk,createSlice } from "@reduxjs/toolkit";
import axios from 'axios'

let url="https://jobsadminpanel-rho.vercel.app"
export const getJobPosts=createAsyncThunk('jobposts/getjobposts',async(state,thunkApi)=>{
    try{
let response=await axios.get(`${url}/get-jobposts`)
return response
    }catch(e){
        if(!e.response.data){
return ({error:"Application error please try later"})
        }else{
            return thunkApi.rejectWithValue(e.response.data)
        }
    }
})


export const createJobPost=createAsyncThunk('jobposts/createjobposts',async(state,thunkApi)=>{
    try{
        console.log("STATE")
        console.log(state)
let response=await axios.post(`https://jobsadminpanel-rho.vercel.app/create-jobpost`,state)
return response
    }catch(e){
        if(!e.response.data){
            return ({error:"Application error please try later"})
                    }else{
                        return thunkApi.rejectWithValue(e.response.data)
                    }
    }
})

export const deletejobPost=createAsyncThunk('jobposts/deletejobposts',async(state,thunkApi)=>{
    try{
let response=await axios.delete(`${url}/delete-post/${state}`)
return response
    }catch(e){
        if(!e.response.data){
            return ({error:"Application error please try later"})
                    }else{
                        return thunkApi.rejectWithValue(e.response.data)
                    }
    
    }
})


export const updateJobPosts=createAsyncThunk('jobposts/updatejobposts',async(state,thunkApi)=>{
    try{
        let response=await axios.post(`${url}/update-jobpost`,state)
        return response
    }catch(e){
        if(!e.response.data){
            return ({error:"Application error please try later"})
                    }else{
                        return thunkApi.rejectWithValue(e.response.data)
                    }
    

    }
})

export const getApplications=createAsyncThunk('jobposts/getapplications',async(state,thunkApi)=>{
    try{
let response=await axios.get(`${url}/get-applications`)
return response
    }catch(e){
        if(!e.response.data){
            return ({error:"Application error please try later"})
                    }else{
                        return thunkApi.rejectWithValue(e.response.data)
                    }
    
    }
})

export const getChartData=createAsyncThunk('jobposts/chardata',async(state,thunkApi)=>{
    try{
let response=await axios.get(`${url}/get-jobdata`)
return response
    }catch(e){
        if(!e.response.data){
            return ({error:"Application error please try later"})
                    }else{
                        return thunkApi.rejectWithValue(e.response.data)
                    }
    
    }
})


const jobpostSlice=createSlice({
    name:'jobpost',
    initialState:{
        jobposts:''
    },
    extraReducers:(builder)=>{
        builder.addCase(getJobPosts.pending,(state,action)=>{
            state.loading=true
        })
        builder.addCase(getJobPosts.fulfilled,(state,action)=>{
            state.jobposts=action.payload
            state.loading=false
        })
        builder.addCase(getJobPosts.rejected,(state,action)=>{
            state.appErr=action?.payload?.message
            state.serverErr=action?.error?.message
        })
    }
})

export default jobpostSlice.reducer